import CV from "../Awshad CV.pdf";

function Resume() {
  return (
    <section id="resume" className="resume">
      <div className="container">
        <div className="section-title">
          <h2>Resume</h2>
          <div className="row">
            <p className="col-md-8 ">Check My Resume</p>
            <div className="col-md-4 d-flex justify-content-md-end cv-btn ">
              <a href={CV} download="Awshad_CV.pdf">
                <button className="btn btn-primary">Download CV</button>
              </a>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <h3 className="resume-title">Professional Summary</h3>
            <div className="resume-item pb-0">
              <h4>Mohamed Awshad</h4>
              <p className="text-justify">
                <em>
                  Full Stack Developer with 4+ years of experience in
                  building, deploying, and optimizing modern web applications and
                  enterprise IT infrastructure. Expert in React, Next.js, PHP
                  (Laravel), and ASP.NET, with strong proficiency in Linux server
                  administration, Apache web server configuration, MySQL/PostgreSQL
                  database optimization, and CI/CD pipeline implementation. Skilled
                  in end-to-end application deployment, DNS management, SSL
                  certificate configuration, Cloudflare integration, and website
                  performance optimization including Core Web Vitals and technical
                  SEO. Proven ability to automate workflows, implement AI-powered
                  solutions, and manage infrastructure across enterprise-scale
                  environments serving 10+ mission-critical healthcare applications.
                </em>
              </p>
              <p>
                <ul>
                  <li>mawsa3454@gmail.com</li>
                  <li>+94 75 680 0099</li>
                  <li>Batticaloa, Sri Lanka</li>
                </ul>
              </p>
            </div>
            <h3 className="resume-title">Education</h3>
            <div className="resume-item">
              <h4>
                BEng (Hons) Software Engineering - First Class Honours
              </h4>
              <h5>2020 - 2021</h5>
              <p>
                <em>London Metropolitan University, UK</em>
              </p>
              <p>
                Completed bachelor's degree in Software Engineering with First
                Class Honours, demonstrating exceptional academic performance and
                technical excellence.
              </p>
            </div>
            <div className="resume-item">
              <h4>
                Pearson BTEC Level 5 Higher National Diploma in Computing -
                Distinction
              </h4>
              <h5>2018 - 2020</h5>
              <p>
                <em>ESOFT Metro Campus, Batticaloa, Sri Lanka</em>
              </p>
              <p>
                Completed Higher National Diploma in Computing with Distinction,
                building a strong foundation in software engineering principles
                and practices.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <h3 className="resume-title">Professional Experience</h3>
            <div className="resume-item">
              <h4>Senior Software Engineer</h4>
              <h5>November 2021 - Present</h5>
              <p>
                <em>HCLTech, Sri Lanka</em>
              </p>
              <p>
                <ul>
                  <li>
                    Managed Linux (RHEL) and Windows Server infrastructure for
                    10+ enterprise healthcare applications, including Apache web
                    server configuration, application deployment, and hosting
                    environment maintenance across development, test, and
                    production environments.
                  </li>
                  <li>
                    Built and maintained CI/CD pipelines to automate deployment
                    processes, reducing deployment time and improving release
                    management efficiency for enterprise applications.
                  </li>
                  <li>
                    Configured and managed DNS records, SSL certificates, and
                    Cloudflare CDN integration to ensure secure, high-performance
                    hosting environments with optimized website performance and
                    Core Web Vitals.
                  </li>
                  <li>
                    Optimized MySQL, PostgreSQL, and SQL Server databases
                    through query optimization, indexing strategies, and stored
                    procedure refinement, improving application performance and
                    reducing query response times.
                  </li>
                  <li>
                    Implemented workflow automation solutions using cron jobs,
                    batch monitoring scripts, and AI-powered tools, reducing
                    manual intervention by 40% and improving operational
                    efficiency across production environments.
                  </li>
                  <li>
                    Led 5+ application migration initiatives involving Linux
                    servers, PHP applications, and PostgreSQL databases,
                    coordinating with infrastructure teams to ensure seamless
                    transitions with zero critical business disruption.
                  </li>
                  <li>
                    Developed and maintained enterprise full-stack applications
                    using React, Next.js, PHP (Laravel), and ASP.NET MVC,
                    building RESTful APIs and responsive user interfaces for
                    mission-critical healthcare systems.
                  </li>
                  <li>
                    Performed website performance optimization including
                    technical SEO implementation, page speed improvements, and
                    Core Web Vitals optimization to enhance user experience and
                    search engine rankings.
                  </li>
                  <li>
                    Investigated and resolved 300+ production incidents and
                    700+ service requests, performing root cause analysis and
                    implementing long-term solutions to improve application
                    stability and reduce recurring issues.
                  </li>
                  <li>
                    Collaborated with cross-functional teams including
                    infrastructure, database administration, and business units
                    to deliver scalable solutions and drive digital growth
                    initiatives across enterprise environments.
                  </li>
                  <li>
                    Led and mentored junior team members, establishing best
                    practices for DevOps, deployment automation, and production
                    support methodologies across L1 and L2 support teams.
                  </li>
                </ul>
              </p>
            </div>
            <div className="resume-item">
              <h4>Independent Software Consultant (Part-time)</h4>
              <h5>September 2019 - Present</h5>
              <p>
                <em>Freelance</em>
              </p>
              <p>
                <ul>
                  <li>
                    Developed and delivered custom web applications using PHP
                    (Laravel), ASP.NET, and React for diverse client
                    requirements.
                  </li>
                  <li>
                    Provided technical support and troubleshooting assistance to
                    clients, resolving software and system issues with clear,
                    accessible communication.
                  </li>
                  <li>
                    Created user-friendly training documentation, guides, and
                    onboarding materials to help non-technical clients confidently
                    adopt delivered systems.
                  </li>
                  <li>
                    Managed end-to-end project delivery, collaborating with
                    clients to ensure quality outcomes within agreed timelines.
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Resume;
